import { Field } from '@gosupersimple/penguino';

import { FilterBinaryOperator } from '@/explore/edit-pipeline/utils/filter';

import {
  CompositeFilterCondition,
  DereferencedPipelineOperation,
  FilterOperation,
  PipelineOperation,
  VariableDefinition,
} from '@/explore/types';
import { isSingleFilterCondition, isValueExpression } from '@/explore/pipeline/operation'; //TODO: move to core
import { getVariableExpression, VariableToQueryVariableTypeMap } from '@/explore/utils';

import { VariableValueType } from '../cell';

export const isFilterOperation = (
  operation: PipelineOperation | DereferencedPipelineOperation,
): operation is FilterOperation => operation.operation === 'filter';

export const ensureValidUseOfVariablesInFilterCondition = (
  condition: CompositeFilterCondition,
  definitions: VariableDefinition[],
): CompositeFilterCondition => {
  if (!isSingleFilterCondition(condition)) {
    return {
      ...condition,
      operands: condition.operands.map((operand) =>
        ensureValidUseOfVariablesInFilterCondition(operand, definitions),
      ),
    };
  }

  if (isSingleFilterCondition(condition) && isValueExpression(condition.value)) {
    const { expression } = condition.value;

    const definition = definitions.find(({ key }) => expression === getVariableExpression(key));
    if (definition === undefined) {
      return condition;
    }

    if (
      VariableToQueryVariableTypeMap[definition.kind] === 'Array' &&
      !['in', 'notin'].includes(condition.operator)
    ) {
      return {
        ...condition,
        operator: condition.operator === '!=' ? 'notin' : 'in',
      };
    }

    if (
      VariableToQueryVariableTypeMap[definition.kind] !== 'Array' &&
      ['in', 'notin'].includes(condition.operator)
    ) {
      return {
        ...condition,
        operator: condition.operator === 'notin' ? '!=' : '==',
      };
    }
  }

  return condition;
};

export const ensureValidUseOfVariablesInFilter = (
  operation: FilterOperation,
  definitions: VariableDefinition[],
): FilterOperation => {
  return {
    ...operation,
    parameters: ensureValidUseOfVariablesInFilterCondition(operation.parameters, definitions),
  };
};

export const getFilterVariableValueType = (
  filterOperator: FilterBinaryOperator,
  fieldType: Field['type'],
): VariableValueType => {
  if (filterOperator === 'in' || filterOperator === 'notin') {
    return 'Array';
  }

  switch (fieldType) {
    case 'Date':
      return 'Date';
    case 'Number':
    case 'Integer':
    case 'Float':
      return 'Number';
    case 'Boolean':
      return 'Boolean';
    default:
      return 'String';
  }
};
